// Re-export unified AssetPickerModal configured for images with filters
import { AssetPickerModal as UnifiedAssetPickerModal } from "@/components/features/shared";
import type { Asset, AssetSource } from "@/types";

interface AssetPickerModalProps {
  isOpen: boolean;
  onClose: () => void;
  /**
   * Receives the picked asset's url, id, source, and (when the user
   * picked from the Characters tab or selected a character-bound
   * generation) the character `folder` so the resulting animation
   * stays grouped under the same character.
   */
  onSelect: (
    url: string,
    assetId?: string,
    source?: AssetSource,
    folder?: string | null,
  ) => void;
}

export function AssetPickerModal({
  isOpen,
  onClose,
  onSelect,
}: AssetPickerModalProps) {
  return (
    <UnifiedAssetPickerModal
      isOpen={isOpen}
      onClose={onClose}
      onSelect={(asset: Asset) =>
        onSelect(asset.url, asset.id, asset.source, asset.folder ?? null)
      }
      assetType="image"
      showFilters
    />
  );
}
